import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import mbxGeocoding from "@mapbox/mapbox-sdk/services/geocoding";

console.log("MAPBOX TOKEN:", process.env.REACT_APP_MAPBOX_TOKEN);

const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;

const mapboxClient = mbxGeocoding({
  accessToken: MAPBOX_TOKEN
});



export default function MultiStepFormModal({ isOpen, onClose, selectedCar }) {
  const steps = [
    {
      id: 1,
      question: "What is your employment status?",
      type: "options",
      name: "employment_status",
      options: ["Employed", "Self-Employed", "Retired/Pension", "Unemployed", "Student"],
    },
    {
      id: 2,
      question: "What is your monthly income? (CAD)",
      type: "options",
      name: "monthly_income",
      options: ["$2500-$3000", "$3001-$3500", "$3501-$4500", "$4500+"],
    },
    {
      id: 3,
      question: "How long have you been receiving this income?",
      type: "options",
      name: "income_duration",
      options: ["Less than 3 months", "3 months–2 years", "2+ years"],
    },
    { id: 4, question: "Where do you work?", type: "text", name: "work_place" },
    { id: 5, question: "What is your job title?", type: "text", name: "job_title" },

    // Address field with Google autocomplete
    { id: 6, question: "What is your address?", type: "address", name: "address" },

    {
  id: 7,
  question: "What is your age?",
  type: "age",
  name: "dob",
},

    {
      id: 8,
      question: "What is your citizenship status?",
      type: "options",
      name: "citizenship",
      options: ["Citizen", "Permanent Resident", "Work Permit", "Student Visa", "Visitor", "Other"],
    },
    { id: 9, question: "How can we get in touch with you?", type: "contact" },
    { id: 10, question: "Confirmation", type: "confirm" },
  ];

  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const [fieldValue, setFieldValue] = useState("");
  const [contactValues, setContactValues] = useState({ full_name: "", phone: "", email: "" });
  const [errors, setErrors] = useState({});
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const addressRef = useRef(null);



if (!MAPBOX_TOKEN) {
  console.error("Mapbox token missing. Check your .env file.");
}


  const [suggestions, setSuggestions] = useState([]);
  
// ---------- HELPERS (ADD HERE) ----------

const calculateDOBFromAge = (age) => {
  const today = new Date();
  const birthYear = today.getFullYear() - age;
  return new Date(birthYear, today.getMonth(), today.getDate())
    .toISOString()
    .split("T")[0];
};

const handleDOBInput = (value) => {
  let digits = value.replace(/\D/g, "");
  digits = digits.slice(0, 8);

  let formatted = "";

  if (digits.length <= 2) {
    formatted = digits;
  } else if (digits.length <= 4) {
    formatted = `${digits.slice(0, 2)} / ${digits.slice(2)}`;
  } else {
    formatted = `${digits.slice(0, 2)} / ${digits.slice(2, 4)} / ${digits.slice(4)}`;
  }

  setFieldValue(formatted);
};



  const current = steps[step];

  // Initialize Google AutocompleteService once
  

  // Generate address suggestions when user types
 useEffect(() => {
  if (current.type !== "address") return;

  if (!fieldValue || fieldValue.length < 3) {
    setSuggestions([]);
    return;
  }

  const delayDebounce = setTimeout(async () => {
    try {
      const res = await mapboxClient
        .forwardGeocode({
          query: fieldValue,
          countries: ["ca"],
          limit: 5,
        })
        .send();

      const features = res.body.features || [];

      const formatted = features.map((item) => ({
        place_id: item.id,
        description: item.place_name,
      }));

      setSuggestions(formatted);
    } catch (err) {
      console.error("Mapbox error:", err);
      setSuggestions([]);
    }
  }, 400);

  return () => clearTimeout(delayDebounce);

}, [fieldValue, current]);

  // When user selects an address
  const handleSelect = (item) => {
    setFieldValue(item.description);
    setSuggestions([]);
  };

  const updateAnswer = (name, value) => {
    setAnswers((prev) => ({ ...prev, [name]: value }));
    setErrors((e) => {
      const copy = { ...e };
      delete copy[name];
      return copy;
    });
  };

  const isValidEmail = (s) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);

  const handleNext = () => {
    // TEXT + ADDRESS
    if (current.type === "text" || current.type === "address") {
      if (!fieldValue || !fieldValue.trim()) {
        setErrors((e) => ({ ...e, [current.name]: "Please enter an answer to continue." }));
        return;
      }
      updateAnswer(current.name, fieldValue.trim());
      setFieldValue("");
    }

    // DOB validation
    // AGE → DOB conversion
if (current.type === "age") {
  const parts = fieldValue.split("/").map(p => p.trim());

  if (parts.length !== 3) {
    setErrors((e) => ({ ...e, dob: "Enter date as DD / MM / YYYY" }));
    return;
  }

  const [dd, mm, yyyy] = parts.map(Number);

  const birth = new Date(yyyy, mm - 1, dd);

  if (
    birth.getFullYear() !== yyyy ||
    birth.getMonth() !== mm - 1 ||
    birth.getDate() !== dd
  ) {
    setErrors((e) => ({ ...e, dob: "Invalid date" }));
    return;
  }

  const today = new Date();
  let age = today.getFullYear() - yyyy;
  const adjust =
    today.getMonth() < mm - 1 ||
    (today.getMonth() === mm - 1 && today.getDate() < dd);
  if (adjust) age--;

  if (age < 18) {
    setErrors((e) => ({ ...e, dob: "You must be at least 18 years old." }));
    return;
  }

  const dobISO = birth.toISOString().split("T")[0];

  updateAnswer("dob", dobISO);
  updateAnswer("age", age);

  setFieldValue("");
}



    // CONTACT
    if (current.type === "contact") {
      const { full_name, phone, email } = contactValues;
      const newErrors = {};
      if (!full_name) newErrors.full_name = "Enter your name.";
      if (!phone) newErrors.phone = "Enter your phone.";
      if (!email || !isValidEmail(email)) newErrors.email = "Enter a valid email.";

      if (Object.keys(newErrors).length) {
        setErrors((e) => ({ ...e, ...newErrors }));
        return;
      }

      updateAnswer("full_name", full_name.trim());
      updateAnswer("phone", phone.trim());
      updateAnswer("email", email.trim());

      setContactValues({ full_name: "", phone: "", email: "" });
      setErrors({});
    }

    // OPTIONS
    if (current.type === "options" && !answers[current.name]) {
      setErrors((e) => ({ ...e, [current.name]: "Please select an option to continue." }));
      return;
    }

    setStep((s) => Math.min(s + 1, steps.length - 1));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleBack = () => {
    setErrors({});
    setStep((s) => (s > 0 ? s - 1 : s));
  };

  const selectOption = (name, value) => {
    updateAnswer(name, value);
    setTimeout(() => setStep((s) => Math.min(s + 1, steps.length - 1)), 150);
  };

  const handleSubmit = async () => {
  if (!acceptedTerms) {
    setErrors((e) => ({
      ...e,
      acceptedTerms: "You must accept the Terms & Conditions to submit.",
    }));
    return;
  }

  setSubmitting(true);

  const payload = {
    selected_car: selectedCar || "Not specified",
    ...answers,
  };

  try {
    const formData = new FormData();

Object.entries(payload).forEach(([key, value]) => {
  formData.append(key, value);
});
// BACKUP → Web3Forms
const backupData = new FormData();

backupData.append("access_key", "c104766a-5832-4d22-81fc-10de5c747d74");

// send all fields
Object.entries(payload).forEach(([key, value]) => {
  backupData.append(key, value);
});

await fetch("https://api.web3forms.com/submit", {
  method: "POST",
  body: backupData,
});

const res = await fetch("https://hooks.zapier.com/hooks/catch/26799411/uxe9gcr/", {
  method: "POST",
  body: formData,
});

    

    if (res.ok)  {
      // ✅ FIRE LEAD ONLY ON SUCCESS
      if (window.fbq) {
        window.fbq("track", "Lead");
      }

      alert("Form submitted successfully!");
      setAnswers({});
      setAcceptedTerms(false);
      setStep(0);
      onClose();
    } else {
      alert("Error submitting form.");
    }
  } catch (err) {
    alert("Network error.");
  } finally {
    setSubmitting(false);
  }
};

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <motion.div
          key={step}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          className="relative bg-gradient-to-br from-[#0a2545] to-[#0d5e63] text-white p-8 rounded-3xl shadow-2xl w-[95%] max-w-lg"
        >
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-teal-300 hover:text-white text-xl font-bold"
          >
            ✕
          </button>

          <div className="text-center mb-5">
            <p className="text-teal-300 font-semibold text-sm mb-1">
              Step {step+1} of {steps.length}
            </p>
            <h2 className="text-2xl font-bold">{current.question}</h2>
          </div>

          <div>
            {/* OPTIONS */}
            {current.type === "options" && (
              <>
                <div className="grid gap-3">
                  {current.options.map((opt) => (
                    <button
                      key={opt}
                      onClick={() => selectOption(current.name, opt)}
                      className={`w-full border rounded-xl py-3 text-lg font-medium transition ${
                        answers[current.name] === opt
                          ? "bg-teal-400 text-[#0a2545]"
                          : "bg-white/10 hover:bg-white/20"
                      }`}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
                {errors[current.name] && (
                  <p className="text-red-300 mt-2">{errors[current.name]}</p>
                )}

                <div className="flex justify-between mt-4">
                  <button onClick={handleBack}>Back</button>
                  <button
                    onClick={handleNext}
                    className="bg-teal-400 px-5 py-2 rounded-full"
                  >
                    Next
                  </button>
                </div>
              </>
            )}

            {/* TEXT */}
            {current.type === "text" && (
              <>
                <input
                  value={fieldValue}
                  onChange={(e) => setFieldValue(e.target.value)}
                  type="text"
                  placeholder="Type your answer..."
                  className="w-full bg-white/10 border border-teal-300 rounded-xl px-4 py-3"
                />

                {errors[current.name] && (
                  <p className="text-red-300 mt-2">{errors[current.name]}</p>
                )}

                <div className="flex justify-between mt-4">
                  <button onClick={handleBack}>Back</button>
                  <button
                    onClick={handleNext}
                    className="bg-teal-400 px-5 py-2 rounded-full"
                  >
                    Next
                  </button>
                </div>
              </>
            )}

            {/* ADDRESS WITH GOOGLE AUTOCOMPLETE */}
            {current.type === "address" && (
              <>
                <input
                  ref={addressRef}
                  value={fieldValue}
                  onChange={(e) => setFieldValue(e.target.value)}
                  type="text"
                  placeholder="Start typing your address..."
                  className="w-full bg-white/10 border border-teal-300 rounded-xl px-4 py-3"
                />

                {errors.address && (
                  <p className="text-red-300 mt-2">{errors.address}</p>
                )}

                {suggestions.length > 0 && (
                  <div className="mt-2 bg-white/10 border border-teal-300 rounded-xl p-2 max-h-56 overflow-y-auto">
                    {suggestions.map((item) => (
                      <div
                        key={item.place_id}
                        onClick={() => handleSelect(item)}
                        className="px-3 py-2 hover:bg-teal-300/20 cursor-pointer rounded-lg"
                      >
                        {item.description}
                      </div>
                    ))}
                  </div>
                )}

                <div className="flex justify-between mt-4">
                  <button onClick={handleBack}>Back</button>
                  <button
                    onClick={handleNext}
                    className="bg-teal-400 px-5 py-2 rounded-full"
                  >
                    Next
                  </button>
                </div>
              </>
            )}

            {/* DOB */}
            {current.type === "age" && (
  <>
    <input
  value={fieldValue}
  onChange={(e) => handleDOBInput(e.target.value)}
  type="text"
  inputMode="numeric"
  placeholder="DD / MM / YYYY"
  maxLength={14}
  className="w-full bg-white/10 border border-teal-300 rounded-xl px-4 py-3"
/>


    {errors.age && <p className="text-red-300 mt-2">{errors.age}</p>}

    <div className="flex justify-between mt-4">
      <button onClick={handleBack}>Back</button>
      <button
        onClick={handleNext}
        className="bg-teal-400 px-5 py-2 rounded-full"
      >
        Next
      </button>
    </div>
  </>
)}


            {/* CONTACT */}
            {current.type === "contact" && (
              <>
                <input
                  type="text"
                  placeholder="Full Name"
                  value={contactValues.full_name}
                  onChange={(e) =>
                    setContactValues({ ...contactValues, full_name: e.target.value })
                  }
                  className="w-full bg-white/10 border border-teal-300 rounded-xl px-4 py-3 mb-2"
                />
                {errors.full_name && <p className="text-red-300">{errors.full_name}</p>}

                <input
                  type="tel"
                  placeholder="Phone Number"
                  value={contactValues.phone}
                  onChange={(e) =>
                    setContactValues({ ...contactValues, phone: e.target.value })
                  }
                  className="w-full bg-white/10 border border-teal-300 rounded-xl px-4 py-3 mb-2"
                />
                {errors.phone && <p className="text-red-300">{errors.phone}</p>}

                <input
                  type="email"
                  placeholder="Email"
                  value={contactValues.email}
                  onChange={(e) =>
                    setContactValues({ ...contactValues, email: e.target.value })
                  }
                  className="w-full bg-white/10 border border-teal-300 rounded-xl px-4 py-3"
                />
                {errors.email && <p className="text-red-300">{errors.email}</p>}

                <div className="flex justify-between mt-4">
                  <button onClick={handleBack}>Back</button>
                  <button
                    onClick={handleNext}
                    className="bg-teal-400 px-5 py-2 rounded-full"
                  >
                    Next
                  </button>
                </div>
              </>
            )}

            {/* CONFIRM */}
            {current.type === "confirm" && (
              <>
                <label className="inline-flex gap-3 items-start mb-4">
                  <input
                    type="checkbox"
                    checked={acceptedTerms}
                    onChange={(e) => {
                      setAcceptedTerms(e.target.checked);
                      setErrors((prev) => {
                        const copy = { ...prev };
                        delete copy.acceptedTerms;
                        return copy;
                      });
                    }}
                  />
                  <div>
                    <div className="font-medium">
                      I have read and accept the Terms & Conditions
                    </div>
                    <div className="text-sm text-gray-300">Required to submit</div>
                  </div>
                </label>

                {errors.acceptedTerms && (
                  <p className="text-red-300">{errors.acceptedTerms}</p>
                )}

                <div className="flex justify-between items-center mt-4">
                  <button onClick={handleBack}>Back</button>
                  <button
                    onClick={handleSubmit}
                    disabled={!acceptedTerms || submitting}
                    className={`px-6 py-2 rounded-full font-semibold ${
                      !acceptedTerms ? "bg-gray-400" : "bg-teal-400"
                    }`}
                  >
                    {submitting ? "Submitting..." : "Submit Application"}
                  </button>
                </div>
              </>
            )}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
